import { render, staticRenderFns } from "./dict-add.vue?vue&type=template&id=7688ee80&"
import script from "./dict-add.vue?vue&type=script&lang=ts&"
export * from "./dict-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports